import { DEFAULT_LOADABLE_STATE, Loadable, LoadableMock, RecursivePartial, UsState, UsStateAbbreviation, UsStateMock } from '@aiwyn/shared';
import { merge } from 'ts-deepmerge';
import { AutoPay, AutoPayMock, Currency, CurrencyCode, CurrencyMock } from '@aiwyn/api';

export interface CommonSettingsStateModel {
  autoPayClients: Loadable<AutoPay[]>;
  usStates: Loadable<UsState[]>;
  clientCurrencies: Record<`${number}`, Loadable<Currency>>;
}

export const DEFAULT_COMMON_SETTINGS_STATE_MODEL: CommonSettingsStateModel = {
  autoPayClients: DEFAULT_LOADABLE_STATE,
  usStates: DEFAULT_LOADABLE_STATE,
  clientCurrencies: {},
};

export class CommonSettingsStateModelMock {
  protected _model: CommonSettingsStateModel = {
    autoPayClients: new LoadableMock<AutoPay[]>([new AutoPayMock().model()]).model(),
    usStates: new LoadableMock<UsState[]>([
      // processing fee
      new UsStateMock().model(),
      // no processing fee
      new UsStateMock({ stateAbbreviation: UsStateAbbreviation.SOUTH_CAROLINA, optOutOfProcessingFee: true }).model(),
      // no credit card
      new UsStateMock({ stateAbbreviation: UsStateAbbreviation.CALIFORNIA, disableCreditCard: true }).model(),
      // no processing fee and no credit card
      new UsStateMock({ stateAbbreviation: UsStateAbbreviation.NEW_YORK, disableCreditCard: true, optOutOfProcessingFee: true }).model(),
    ]).model(),
    clientCurrencies: {
      8: new LoadableMock<Currency>(new CurrencyMock().model()).model(),
      13: new LoadableMock<Currency>(new CurrencyMock({ id: 2, code: CurrencyCode.GBP, symbol: '£' }).model()).model(),
    },
  };

  constructor(overrides: RecursivePartial<CommonSettingsStateModel> = {}) {
    this._model = merge.withOptions(
      { mergeArrays: false },
      this._model,
      overrides,
    ) as unknown as CommonSettingsStateModel;
  }

  public model(): CommonSettingsStateModel {
    return this._model;
  }
}
